<template>
  <div class="Melamine">
    <div class="title">Methacrylic Acid</div>

    <div class="table">
      <label>Specification:</label>
      <el-table border :data="tableData" stripe>
        <el-table-column prop="Items" label="Items"> </el-table-column>
        <el-table-column prop="Index" label="Index"> </el-table-column>
      </el-table>
    </div>
    <div class="item-huanhang">
      <label>Package:</label>
      <p>in 200KG drum; 20'FCL=16MT or in 25CBM ISO taniks, 24mt per tank</p>
    </div>
    <div class="item-huanhang">
      <label>Uses:</label>
      <p>
        For manufacturing of organic glass intermediate, acrylics,organic glass
        resin and adhesive agent; for preparation of textile treatment agent in
        textile industry; for manufacturing of leather treatment; for
        manufacturing of cooling and thermohardening ladquer
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: "ACTdetail",
  data() {
    return {
      tableData: [
        { Items: "Appearance", Index: "Colorless Liquid" },
        { Items: "Purity %", Index: "99.5% Min" },
        { Items: "Water%", Index: "0.3% Max" },
        { Items: "Color(Pt-Co)", Index: "10Max" },
        { Items: "Inhibitor(MEHQ) PPM", Index: "" },
      ],
    };
  },
};
</script>

<style lang="less" scoped>
.Melamine {
  padding: 10px 30px;
  height: 100%;
  overflow-y: auto;
  label {
    font-size: 20px;
    font-weight: bold;
    height: 40px;
    line-height: 40px;
  }
  p {
    color: gray;
    font-weight: bold;
    line-height: 30px;
  }
  .title {
    font-size: 30px;
    font-weight: bold;
    color: #042a42cf;
  }
  .table {
    margin-top: 10px;
    display: flex;
    flex-direction: column;
  }
  .item {
    margin-top: 10px;
    display: flex;
    align-items: center;
    column-gap: 10px;
  }
  .item-huanhang {
    display: flex;
    flex-direction: column;
    column-gap: 20px;
  }
}
</style>
